module.exports = __webpack_public_path__ + "img/confirmationMobile.50d408ad.svg";